import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translation resources from JSON files
import enCommon from './locales/en/common.json';
import enNavigation from './locales/en/navigation.json';
import enBusiness from './locales/en/business.json';

// Import modular public components
import enAbout from './locales/en/public/about.json';
import enHomepage from './locales/en/public/homepage.json';
import enActivities from './locales/en/public/activities.json';
import enBusinessPublic from './locales/en/public/publicbusinessprofile.json';
import enForBusiness from './locales/en/public/forbusiness.json';
import enOfferings from './locales/en/public/offerings.json';
import enContact from './locales/en/public/contact.json';
import enCommonPublic from './locales/en/public/common.json';
import enCustomAdventures from './locales/en/public/customAdventures.json';

// Import modular business components
import enAnalytics from './locales/en/business/analytics.json';
import enDashboard from './locales/en/business/dashboard.json';
import enCommunication from './locales/en/business/communication.json';
import enActivitiesBusiness from './locales/en/business/activities.json';
import enRegistration from './locales/en/business/registration.json';
import enBookings from './locales/en/business/bookings.json';
import enStaff from './locales/en/business/staff.json';
import enLivestock from './locales/en/business/livestock.json';
import enFunding from './locales/en/business/funding.json';
import enSettings from './locales/en/business/settings.json';
import enCalendar from './locales/en/business/calendar.json';
import enCommonBusiness from './locales/en/business/common.json';
import enHomepageBusiness from './locales/en/business/homepage.json';
import enQuickActions from './locales/en/business/quickActions.json';
import enPayment from './locales/en/business/payment.json';

// Spanish translations
import esCommon from './locales/es/common.json';
import esNavigation from './locales/es/navigation.json';
import esCustomAdventures from './locales/es/public/customAdventures.json';
import esBusiness from './locales/es/business.json';

// Import modular public components - Spanish
import esAbout from './locales/es/public/about.json';
import esHomepage from './locales/es/public/homepage.json';
import esActivities from './locales/es/public/activities.json';
import esBusinessPublic from './locales/es/public/publicbusinessprofile.json';
import esForBusiness from './locales/es/public/forbusiness.json';
import esOfferings from './locales/es/public/offerings.json';
import esContact from './locales/es/public/contact.json';
import esCommonPublic from './locales/es/public/common.json';

// Import modular business components - Spanish
import esAnalytics from './locales/es/business/analytics.json';
import esDashboard from './locales/es/business/dashboard.json';
import esCommunication from './locales/es/business/communication.json';
import esActivitiesBusiness from './locales/es/business/activities.json';
import esRegistration from './locales/es/business/registration.json';
import esBookings from './locales/es/business/bookings.json';
import esStaff from './locales/es/business/staff.json';
import esLivestock from './locales/es/business/livestock.json';
import esFunding from './locales/es/business/funding.json';
import esSettings from './locales/es/business/settings.json';
import esCalendar from './locales/es/business/calendar.json';
import esCommonBusiness from './locales/es/business/common.json';
import esHomepageBusiness from './locales/es/business/homepage.json';
import esQuickActions from './locales/es/business/quickActions.json';
import esPayment from './locales/es/business/payment.json';

const resources = {
  en: {
    common: enCommon,
    navigation: enNavigation,
    public: {
      about: enAbout,
      homepage: enHomepage,
      activities: enActivities,
      business: enBusinessPublic,
      forbusiness: enForBusiness,
      offerings: enOfferings,
      contact: enContact,
      common: enCommonPublic,
      customAdventures: enCustomAdventures
    },
    business: {
      main: enBusiness,
      analytics: enAnalytics,
      dashboard: enDashboard,
      communication: enCommunication,
      activities: enActivitiesBusiness,
      registration: enRegistration,
      bookings: enBookings,
      staff: enStaff,
      livestock: enLivestock,
      funding: enFunding,
      settings: enSettings,
      calendar: enCalendar,
      common: enCommonBusiness,
      homepage: enHomepageBusiness,
      quickActions: enQuickActions,
      payment: enPayment
    }
  },
  es: {
    common: esCommon,
    navigation: esNavigation,
    public: {
      about: esAbout,
      homepage: esHomepage,
      activities: esActivities,
      business: esBusinessPublic,
      forbusiness: esForBusiness,
      offerings: esOfferings,
      contact: esContact,
      common: esCommonPublic,
      customAdventures: esCustomAdventures
    },
    business: {
      main: esBusiness,
      analytics: esAnalytics,
      dashboard: esDashboard,
      communication: esCommunication,
      activities: esActivitiesBusiness,
      registration: esRegistration,
      bookings: esBookings,
      staff: esStaff,
      livestock: esLivestock,
      funding: esFunding,
      settings: esSettings,
      calendar: esCalendar,
      common: esCommonBusiness,
      homepage: esHomepageBusiness,
      quickActions: esQuickActions,
      payment: esPayment
    }
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    lng: 'en',
    fallbackLng: 'en',
    defaultNS: 'common',
    ns: ['common', 'navigation', 'public', 'business'],
    
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
      lookupLocalStorage: 'i18nextLng',
    },
    
    interpolation: {
      escapeValue: false,
    },
    
    react: {
      useSuspense: false,
    },
    
    debug: process.env.NODE_ENV === 'development',
  });

// Keep <html lang> in sync with the active language (accessibility + SEO)
i18n.on('languageChanged', (lng) => {
  document.documentElement.lang = lng.split('-')[0];
});
document.documentElement.lang = (i18n.language || 'en').split('-')[0];

export default i18n; 